import { ClaudeTemplate } from "../types";

/** Adform FLOW como DSP. */
export const adformTemplate: ClaudeTemplate = {
  id: "adform",
  tool: "Adform FLOW (DSP)",
  url: "https://flow.adform.com/ (si redirige a otra URL de login, sigue)",
  hierarchy:
    "Agency → Client (advertiser) → Campaign → Line items → Banners / creatives",
  idHint: "ID de la campaña (columna ID o URL)",
  steps: `
### 1. Entrar en el cliente (puede que ya estés dentro)
1. Abre Adform ({{url}}). Si ya está abierto, sigue.
2. Elige el **Client** {{client}}. Si hay varios, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, créala (campaña de DSP / programática):
   - Name: {{names.order}}
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}}. Moneda {{goal.currency}}.
   - Objetivo / KPI: {{goal.kpi}} = {{goal.netUnitCost}}.
   - Tracking: el que use la agencia por defecto.

### 3. Line item
1. Name: {{names.line}}
2. Fechas y presupuesto: los de la campaña salvo que las notas digan otra cosa. Pacing even.
3. Puja: en torno a {{goal.netUnitCost}}.
4. Targeting: geografía {{target.geography}} (país {{goal.country}}), idioma {{target.language}}, dispositivos {{target.technology}}, audiencias {{target.audience}}, intereses {{target.interests}}, demografía {{target.gender}} {{target.age}}, exclusiones {{target.exclusions}}, visibilidad {{goal.visibility}}.
5. Inventario: el que digan las notas (deals, sites, exchanges). Si no lo dicen, pregunta.

### 4. Banners
1. Sube o asigna las creatividades del bloque "Creatividades". Landing con UTM: bloque "URLs de destino".
2. Deja todo **inactivo**.
`,
};
